import _ from 'lodash'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import Translate from "../modules/local/Translate"
import React from "react"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)

export function convertToDayjs(x) {
    if (dayjs.isDayjs(x) && x.isValid()) return x

    let d = dayjs(x)
    if (!d.isValid()) d = dayjs(x, 'DD/MM/YYYY', true)
    if (!d.isValid()) d = dayjs(x, 'DD-MM-YYYY', true)
    if (!d.isValid()) d = dayjs(x, 'YYYY-MM-DDTHH:mm:ssZ', true)
    if (!d.isValid()) d = dayjs(x, 'DD/MM/YY', true)
    if (!d.isValid()) d = dayjs(x, 'MM/DD/YY', true)

    return d
}

export const timeFromSeconds = (seconds = 0) => {
    const number = _.defaultTo(seconds, 0)
    return [Math.floor(number / 3600), Math.floor(number / 60) % 60, number % 60]
}

export const dayjsFromSeconds = (value = 0) => {
    const [hours = 0, minutes = 0, seconds = 0] = timeFromSeconds(value)
    return dayjs().set('hour', hours).set('minute', minutes).set('second', seconds)
}

export const timeFromMinutes = (minutes = 0) => {
    const number = _.defaultTo(minutes, 0)
    return [
        Math.floor(number / 60),  // giờ
        number % 60               // phút
    ]
}

export const dayjsFromMinutes = (value = 0) => {
    const [hours = 0, minutes = 0] = timeFromMinutes(value)
    return dayjs().set('hour', hours).set('minute', minutes).set('second', 0)
}

export const minutesFromDayjs = (value) => {
    if (dayjs.isDayjs(value)) {
        const hours = value.hour() * 3600
        const minutes = value.minute() * 60
        const seconds = value.second()
        return Math.floor((hours + minutes + seconds) / 60)
    }
    return 0
}

export const secondsFromDayjs = (value) => {
    if (dayjs.isDayjs(value)) {
        return value.hour() * 3600 + value.minute() * 60 + value.second()
    }
    return 0
}

export function parseDayjs(date) {
    return date && dayjs(date).isValid() ? dayjs(date) : undefined
}

export function isValidDate(value, format) {
    try {
        const date = dayjs(value, format, true)
        return date.isValid() ? date.format(format) : false
    } catch (error) {
        return false
    }
}

export function getDateString(date) {
    if (!!date && dayjs.isDayjs(date)) {
        return date.local().format()
    }
    return date === null ? null : undefined
}

export function formatDate(date, format = 'YYYY-MM-DDTHH:mm:ssZ') {
    const _date = convertToDayjs(date)
    if (_date && _date.isValid()) {
        return _date.local().format(format)
    }
    return (date === null) ? null : undefined
}

export function hasExpired(date) {
    if (!date) return false
    return dayjs(date).isBefore(dayjs())
}

export const renderFromToTime = (from = null, to = null) => {
    const fromDate = dayjs(from)
    const toDate = dayjs(to)

    if (!to) {
        return fromDate.hour() === 0 && fromDate.minute() === 0
            ? fromDate.format('DD/MM/YYYY')
            : fromDate.format('HH:mm - DD/MM/YYYY')
    } else if (!from) {
        return toDate.hour() === 0 && toDate.minute() === 0
            ? toDate.format('DD/MM/YYYY')
            : toDate.format('HH:mm - DD/MM/YYYY')
    }

    if (fromDate.isSame(toDate, 'day')) {
        return fromDate.hour() === 0 && fromDate.minute() === 0 &&
        toDate.hour() === 0 && toDate.minute() === 0
            ? fromDate.format('DD/MM/YYYY')
            : (
                <Translate>
                    {(t) =>
                        `${t('date')} ${fromDate.format('DD/MM/YYYY')}, ${_.lowerCase(t('from'))} ${fromDate.format('HH:mm')} ${t('to')} ${toDate.format('HH:mm')}`
                    }
                </Translate>
            )
    } else {
        return fromDate.hour() === 0 && fromDate.minute() === 0 &&
        toDate.hour() === 0 && toDate.minute() === 0
            ? (
                <Translate>
                    {(t) =>
                        `${t('from date')} ${fromDate.format('DD/MM/YYYY')} ${t('to date')} ${toDate.format('DD/MM/YYYY')}`
                    }
                </Translate>
            )
            : (
                <Translate>
                    {(t) =>
                        `${t('from')} ${fromDate.format('HH:mm - DD/MM/YYYY')} ${t('to')} ${toDate.format('HH:mm - DD/MM/YYYY')}`
                    }
                </Translate>
            )
    }
}

export const renderFromToDate = (from = null, to = null, format = 'DD/MM/YYYY') => {
    const fromDate = dayjs(from)
    const toDate = dayjs(to)

    if (!to) return fromDate.format(format)
    else if (!from) return toDate.format(format)

    return (
        <Translate>
            {(t) =>
                `${t('from date')} ${fromDate.format(format)} ${t('to date')} ${toDate.format(format)}`
            }
        </Translate>
    )
}